import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {fetchUserByIp, resetUserByIp} from "../../creators/user.findIp";
import Icon from './Icon';
import {SpinLoader} from "./Loader";

import {Link} from "react-router-dom";
import createLink from "../../libs/createLink";
import Avatar from "./Avatar";
import DateSince from "./Date";


class UserByIp extends React.Component {
    constructor(props){
        super(props);

        this.props.fetchUserByIp({ip : this.props.ip});
    };

    componentWillUnmount() {
        this.props.resetUserByIp();
    }


    render() {
        return <div id="user-by-ip">
            <div className="card">
                <div className="topline">
                    <span>Utilisateurs avec cette adresse ip : "{this.props.ip}"</span> <span onClick={() => this.props.handleClose()}><Icon
                    type="close"/></span>
                </div>
                <div className="wrapper">
                    {this.props.userByIpLoading ? (<SpinLoader className={"small"}/>) : null}
                    {this.props.userByIpInitialized && !this.props.userByIpLoading ?
                        this.props.userByIpTotal === 0 ? <div>Aucune information</div> :
                        this.props.userByIp.map((item) => (
                                    <div key={item._id} className="recent-activity">
                                        <Link to={createLink('userProfile', item)} target={"_blank"} >
                                            <Avatar avatar={item.profile && item.profile.avatar}
                                                    gender={item.profile && item.profile.gender}/>
                                        </Link>
                                        <div className="user-infos">
                                            <Link
                                                to={createLink('userProfile', item)} target={"_blank"} >{item.username || ""}</Link>
                                            <div className="timer">
                                                <DateSince
                                                    date={item.sessionCreatedAt}
                                                    prefix={true}
                                                    currentFormat={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )
                            )
                     : null}
                </div>
            </div>
        </div>

    }
}

const mapStateToProps = (state) => {
    return {
        userByIp: state.userByIp.data,
        userByIpTotal: state.userByIp.data?.length,
        userByIpLoading: state.userByIp.loading,
        userByIpInitialized: state.userByIp.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserByIp,
    resetUserByIp
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserByIp);